/** 
*@author: Marmini Alluri
*@Description :This is Color Code Master screen
**/
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import localStorage from '../../../../utils/localStorage';
import { COLORCODES, IPAddress, MASTERUPLOAD } from '../../../../commons/api';
import StyledTable from '../../../../commons/styles/table';
import { DrawerFooter } from '../../../../commons/styles/layout';
import { CreateMasters, UpadateMasters, deleteMasters, getHierarchyLevels, getParametersList, downloadCompleteData } from '../../APICalls';
import HierarchyModal from './Utils/HierarchyModal';
import { Form, Input, message, Button, Drawer, Tooltip, Popconfirm, Upload, Select, Modal, Checkbox } from 'antd';
import {
    EditOutlined,
    DeleteOutlined,
    QuestionCircleOutlined,
    PlusOutlined,
    UploadOutlined,
    DownloadOutlined,
    UpSquareOutlined,
    SearchOutlined
} from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import translation from '../../Utils/translation';
const ApiList = {
    CreateAssetType: `${COLORCODES.Get}`,
    UpdateAssetType: `${COLORCODES.Upsert}`,
    DeleteAssetType: `${COLORCODES.Delete}`,
    Download: `${COLORCODES.Download}`
};
const { Option } = Select;

const ColorCodes = (props) => {
    const [formObject, setFormObject] = useState({});
    const [list, setList] = useState([]);
    const [fileName, setFileName] = useState();
    const [visibleAttributes, setVisibleAttributes] = useState(false);
    const [translationCache, setTranslationCache] = useState(props.translationCache);
    const [keyData, setKeyData] = useState('');
    const [typeChangeModal, setTypeChangeModal] = useState(false);
    const [, setSelectedType] = useState('');
    const [searchText, setSearchText] = useState('');
    const [treeVisible, setTreeVisible] = useState(false);
    const [selectedDevice, setSelectedDevice] = useState([]);
    const [selectedDeviceObject, setSelectedDeviceObject] = useState('');
    const [checkedValue, setCheckedValue] = useState([]);
    const [hierarchy, setHierarchy] = useState([]);
    const [type, setType] = useState('Device');
    const [parametersList, setParameterList] = useState({});
    const [selectedParameterType, setSelectedParameterType] = useState('');
    const [ParameterListByType, setParameterListByType] = useState([]);
    const [selectedParameter, setSelectedParameter] = useState([]);
    const hForm = useRef(null);
    const searchInput = useRef(null);

    useEffect(() => {
        getHierarchyData();
        _getList();
        getFileDownloadName();
        // downloadCompleteData();
    }, []);

    const getFileDownloadName = async () => {
        let fileName = await downloadCompleteData(ApiList.Download);
        let datafile = fileName && fileName.file ? fileName.file : '';
        setFileName(datafile);
    };
    useEffect(() => {
        if (props.translationCache !== translationCache) {
            setTranslationCache(props.translationCache);
        }
    }, [props.translationCache, translationCache]);

    const getHierarchyData = async () => {
        let hierarchyCode = props.defaultHiearchy?.HierarchyCode;
        const hierarchyApi = await getHierarchyLevels(hierarchyCode);
        setHierarchy(hierarchyApi);
    };

    const onModalsOk = (e) => {
        e.preventDefault();
        fieldOnChange(checkedValue, selectedDeviceObject);
        setTreeVisible(false);
        setType(type);
    };

    const onModalCancel = () => {
        if (selectedDevice && Array.isArray(selectedDevice) && selectedDevice.length > 0) {
            setCheckedValue(selectedDevice);
        } else {
            setCheckedValue([]);
        }
        let formId = hForm.current && hForm.current.getFieldsValue();

        if (!formId.Id && !selectedDevice) {
            setType('Device');
        }
        setTreeVisible(false);

    };

    const hierarchyDropdownChange = (value, data, key) => {
        setCheckedValue(value);
        setSelectedDeviceObject(data);
        setKeyData(key);
    };


    const checkboxOnChange = (SelectedValue) => {

        let form = hForm.current && hForm.current.getFieldsValue();

        if (form.selectedDevice && form.selectedDevice !== null && form.selectedDevice !== undefined) {
            if (type !== SelectedValue && checkedValue.length !== 0) {
                setTypeChangeModal(true);
                setSelectedType(selectedDevice);
            } else {
                setType(SelectedValue);
            }
        } else {
            if (
                selectedDevice &&
                Array.isArray(selectedDevice) &&
                selectedDevice.length > 0 &&
                type !== SelectedValue &&
                checkedValue.length !== 0
            ) {
                setTypeChangeModal(true);
                setSelectedType(SelectedValue);
            } else {
                setType(SelectedValue);
                setCheckedValue([]);
                setSelectedDevice([]);
                setSelectedDeviceObject(null);
            }
        }
        // if (type === 'Asset') {
        //     // If clicking the already selected one, switch to Asset as default
        //     setType(type);
        //     // setTypeChangeModal(true);
        //   } else {
        //     setType(type);
        //     // setTypeChangeModal(true);
        //   }
        setHierarchy(hierarchy);
    };

    const onTypeChangeModalOk = () => {
        setType(type === 'Device' ? 'Asset' : 'Device');
        setTypeChangeModal(false);
        setSelectedDevice([]);
        setCheckedValue([]);
        setSelectedDeviceObject('');
    };

    const fieldOnChange = async (value, data) => {
        let val = [];
        val.push(value);
        let ParameterList = {};
        let payload = {};
        const siteId = localStorage.get('currentSite');
        if (type === 'Asset') {
            if (value.length === 6) {
                value.shift();
                payload = {
                    AssetCode: val,
                    SiteId: siteId,
                    CodeType: 'Asset'
                };
                ParameterList = await getParametersList(payload);
            } else {
                payload = {
                    AssetCode: val,
                    SiteId: siteId,
                    CodeType: 'Asset'
                };
                ParameterList = await getParametersList(payload);
            }
        } else {
            if (value.length === 6) {
                payload = {
                    DeviceCode: val,
                    SiteId: siteId,
                    CodeType: 'Device'
                };
                value.shift();
                ParameterList = await getParametersList(payload);
            } else {
                payload = {
                    DeviceCode: val,
                    SiteId: siteId,
                    CodeType: 'Device'
                };
                ParameterList = await getParametersList(payload);
            }
        }

        setCheckedValue(data ? [data] : value);
        setSelectedDevice(data ? [data] : value);
        setParameterList(ParameterList);
        if (hForm.current) {
            hForm.current.setFieldsValue({
                selectedDevice: data ? [data] : value
            });
        }
    };

    const OnParameterTypeChange = (value) => {
        hForm.current.setFieldsValue({
            Tag: value
        });
        setParameterListByType(parametersList[value]);
        setSelectedParameterType(value);
    };

    const OnParameterChange = (value) => {
        // if (type === "Asset") {
        //   value.shift();
        //   setSelectedParameter(value);
        // } else if (type === "Device") {
        //   value.shift();
        //   setSelectedParameter(value);
        // } else {
        setSelectedParameter(value);
        // }
    };

    // const downloadCompleteData = () => {
    //     // let tableName = `sitemaster."SM_ColorCodes"`;
    //     const siteId = localStorage.get('currentSite');
    //     const accessToken = localStorage.get('accessToken');
    //     let payload = {
    //         url: `${MASTERUPLOAD.DOWNLOAD}?SiteId=${siteId}&TableName=${tableName}&Site=${"true"}`,
    //         method: 'GET',
    //         headers: {
    //             Authorization: `Bearer ${accessToken}`
    //         }
    //     };
    //     return axios(payload)
    //         .then((response) => {
    //             setFileName(response.data.file);
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // };

    const deleteCompleteData = () => {
        let tableName = `sitemaster."SM_ColorCodes"`;
        const siteId = localStorage.get('currentSite');
        const accessToken = localStorage.get('accessToken');
        let payload = {
            url: `${MASTERUPLOAD.Delete}?SiteId=${siteId}&TableName=${tableName}`,
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        };
        return axios(payload)
            .then((response) => {
                if (response.data && response.data.message) {
                    message.success(response.data.message);
                    _getList();
                    getFileDownloadName();
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const _getList = () => {
        const siteId = localStorage.get('currentSite');
        const accessToken = localStorage.get('accessToken');
        let url = `${COLORCODES.Get}?SiteId=${siteId}`;

        let orgHeaders = {
            method: 'Get',
            url,
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        };

        axios(orgHeaders)
            .then((response) => {
                setList(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const _editRecord = async (editObject) => {
        const siteId = editObject.SiteId;
        const codeType = editObject.CodeType;
        setType(codeType);
        const assetOrDeviceCode = codeType === 'Asset' ? editObject.Asset : editObject.Device;

        // Build payload for getParametersList
        const payload = codeType === 'Asset'
            ? { AssetCode: [[`${siteId}_${assetOrDeviceCode}`]], SiteId: siteId, CodeType: codeType }
            : { DeviceCode: [[`${siteId}_${assetOrDeviceCode}`]], SiteId: siteId, CodeType: codeType };

        // Fetch parameter list
        const parameterListData = await getParametersList(payload);

        // Get the list for the current Tag (e.g., 'Operational')
        const parameterListByType = parameterListData[editObject.Tag] || [];

        // If you want to combine all types:
        // const combinedList = [
        //   ...(parameterListData.Fault || []),
        //   ...(parameterListData.Operational || []),
        //   ...(parameterListData.Status || [])
        // ];

        // Set your states/form fields as needed
        setSelectedDevice(assetOrDeviceCode);
        setCheckedValue(assetOrDeviceCode);
        setParameterList(parameterListData);
        setParameterListByType(parameterListByType);
        setVisibleAttributes(true);
        setFormObject(editObject);

        if (hForm.current) {
            hForm.current.setFieldsValue({
                selectedDevice: assetOrDeviceCode,
                checkedValue: assetOrDeviceCode,
                Tag: editObject.Tag,
                Parameter: editObject.Parameter,
                UpperLimit: editObject.UpperLimit,
                LowerLimit: editObject.LowerLimit,
                Limit: editObject.Limit,
                ColorCode: editObject.ColorCode,
            });
        }
    };

    const deleteRecord = async (record) => {
        let deleteResponse = await deleteMasters(ApiList.DeleteAssetType, record.Id);
        message.success(deleteResponse && deleteResponse.message);
        _getList();
        getFileDownloadName();
    };

    const onFinish = async () => {
        hForm.current &&
            hForm.current
                .validateFields()
                .then(async (values) => {
                    let payload = {
                        Id: formObject.Id,
                        Code: formObject.Id ? selectedDevice : keyData,
                        CodeType: type,
                        Tag: values.Tag,
                        Parameter: values.Parameter,
                        UpperLimit: values.UpperLimit,
                        LowerLimit: values.LowerLimit,
                        Limit: values.Limit,
                        ColorCode: values.ColorCode,
                    };

                    if (formObject && formObject.Id) {
                        let UpdateResponse = await UpadateMasters(
                            ApiList.UpdateAssetType,
                            payload,
                            formObject.Id
                        );
                        if (UpdateResponse && UpdateResponse.message) {
                            message.success(UpdateResponse.message);
                        }
                    } else {
                        let createResponse = await CreateMasters(ApiList.UpdateAssetType, payload);
                        if (createResponse && createResponse.message) {
                            message.success(createResponse.message);
                        }
                    }
                    _getList();
                    getFileDownloadName();
                    hForm.current &&
                        hForm.current.setFieldsValue({
                            Asset: null,
                            Device: null,
                            Parameter: null,
                            Tag: null,
                            UpperLimit: null,
                            LowerLimit: null,
                            Limit: null,
                            ColorCode: null,
                        });
                    setFormObject({});
                    setVisibleAttributes(false);
                    setCheckedValue([]);
                    setSelectedDevice([]);
                })
                .catch((error) => {
                    console.log(error);
                });
    };

    const OpenDrawer = () => {
        hForm.current &&
            hForm.current.setFieldsValue({
                Asset: null,
                Device: null,
                Parameter: null,
                Tag: null,
                UpperLimit: null,
                LowerLimit: null,
                Limit: null,
                ColorCode: null,
                selectedDevice: null
            });
        let formObject = {
        };
        setVisibleAttributes(true);
        setFormObject(formObject);
        setSelectedDeviceObject('');
        setCheckedValue([]);
        setSelectedDevice([]);
    };

    const onClose = () => {
        hForm.current &&
            hForm.current.setFieldsValue({
                Asset: null,
                Device: null,
                Parameter: null,
                Tag: null,
                UpperLimit: null,
                LowerLimit: null,
                Limit: null,
                ColorCode: null,
                selectedDevice: null,
            });
        setVisibleAttributes(false);
        setFormObject({});
        setSelectedDeviceObject('');
        setCheckedValue([]);
        setSelectedDevice([]);
    };

    const handleSearch = (selectedKeys, confirm) => {
        confirm();
        setSearchText(selectedKeys[0]);
    };

    const handleReset = (clearFilters, confirm) => {
        clearFilters();
        handleSearch([], confirm);
    };

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={searchInput}
                    placeholder={"search"}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    onClick={() => handleSearch(selectedKeys, confirm)}
                    icon={<SearchOutlined />}

                    style={{ width: 90, marginRight: 8 }}
                >
                    {"search"}
                </Button>
                <Button
                    onClick={() => handleReset(clearFilters, confirm)}

                    style={{ width: 90 }}
                >
                    {"Reset"}
                </Button>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
        ),
        onFilter: (value, record) =>
            record &&
            record[dataIndex] &&
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: () => {
            setTimeout(() => searchInput.current.select());
        },
        render: (text) => (
            <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[searchText]}
                autoEscape
                textToHighlight={text && text.toString()}
            />
        )
    });

    const columns = [
        {
            title: translation(translationCache, 'Asset'),
            dataIndex: 'Asset',
            key: 'Asset',
            ...getColumnSearchProps('Asset'),
        },
        {
            title: translation(translationCache, 'Device'),
            dataIndex: 'Device',
            key: 'Device',
            ...getColumnSearchProps('Device'),
        },
        {
            title: translation(translationCache, 'Parameter'),
            dataIndex: 'Parameter',
            key: 'Parameter',
            ...getColumnSearchProps('Parameter'),
        },
        {
            title: translation(translationCache, 'ParameterType'),
            dataIndex: 'Tag',
            key: 'Tag',
            ...getColumnSearchProps('Tag'),
        },
        {
            title: translation(translationCache, 'Upper Limit'),
            dataIndex: 'UpperLimit',
            key: 'UpperLimit',
            ...getColumnSearchProps('UpperLimit'),
        }, {
            title: translation(translationCache, 'Lower Limit'),
            dataIndex: 'LowerLimit',
            key: 'LowerLimit',
            ...getColumnSearchProps('LowerLimit'),
        },
        {
            title: translation(translationCache, 'Color Code'),
            dataIndex: 'ColorCode',
            key: 'ColorCode',
            ...getColumnSearchProps('ColorCode'),
        },
        {
            title: translation(translationCache, 'Action'),
            dataIndex: 'Action',
            render: (text, record) => (
                <>
                    <Button onClick={() => _editRecord(record)} >
                        <Tooltip title={translation(translationCache, "Edit")}>
                            <EditOutlined />
                        </Tooltip>
                    </Button>
                    <Popconfirm
                        title={translation(translationCache, 'Are You Sure That You Want To Delete')}
                        icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                        onConfirm={() => deleteRecord(record)}
                        okText={translation(translationCache, 'yes')}
                        cancelText={translation(translationCache, 'No')}
                    >
                        <Button >
                            <span>
                                <Tooltip title={translation(translationCache, 'Delete')}>
                                    <DeleteOutlined />
                                </Tooltip>
                            </span>
                        </Button>
                    </Popconfirm>
                </>
            )
        }
    ];
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');

    // let tableName = `sitemaster."SM_ColorCodes"`;
    return (
        <div style={{ minHeight: window.innerHeight - 143 }}>
            <div style={{ display: 'flex', justifyContent: 'right', padding: '20px' }}>
                <Button type="primary" style={{
                    marginRight: '10px'
                }}
                    onClick={OpenDrawer}>
                    <PlusOutlined /> {translation(translationCache, 'Add Color Code')}
                </Button>
                <div style={{
                    marginRight: '10px'
                }}>
                    <Upload
                        name="file"
                        action={`${COLORCODES.Upload}?SiteId=${siteId}`}
                        headers={{
                            Authorization: `Bearer ${accessToken}`
                        }}
                        onChange={(info) => {
                            let fileList = [...info.fileList];
                            fileList && Array.isArray(fileList) && fileList.map(file => {
                                if (file.response && file.status === 'error') {
                                    file.error = {
                                        statusText: file.response.message || 'file upload failed.'
                                    };
                                }
                                return file;
                            });
                            if (info.file.status === 'done') {
                                message.success(`${info.file.name} file uploaded successfully`);
                                _getList();
                            } else if (info.file.status === 'error') {
                                message.error(`${info.file.response.message}`);
                            }
                        }}
                        beforeUpload={(file) => {
                            const isCSV = file.type === 'text/csv' || file.name.endsWith('.csv');
                            if (!isCSV) {
                                message.error('You can only upload CSV files!');
                            }
                            return isCSV || Upload.LIST_IGNORE;
                        }}
                        showUploadList={false}
                    >
                        <Button type="primary" icon={<UploadOutlined />}>{translation(translationCache, 'Bulk Data Upload')}
                        </Button>
                    </Upload>
                </div>

                <Tooltip title={fileName ? 'Download' : 'Error in Download API'}>
                    <Button
                        disabled={fileName ? false : true}
                        type="primary"
                        style={{ marginRight: '10px' }}
                    >
                        <a href={`${IPAddress.LOCAL}/api/downloads/${fileName}`}>
                            <DownloadOutlined />
                            {translation(translationCache, 'Download Complete Data')}
                        </a>
                    </Button>
                </Tooltip>

                <Button
                    type="primary"
                    style={{
                        marginRight: '10px'
                    }}
                    onClick={() => deleteCompleteData()}
                >
                    <DeleteOutlined />
                    {translation(translationCache, 'Delete Complete Data')}
                </Button>
            </div>
            <StyledTable size="small"
                columns={columns}
                dataSource={list && Array.isArray(list) ? list : []}
                pagination={
                    list && Array.isArray(list) && list.length > 10
                        ? {
                            pageSize: '10'
                        }
                        : false
                }
            />
            <Drawer
                title={
                    formObject && formObject.Id
                        ? translation(translationCache, 'Update')
                        : translation(translationCache, 'Create')
                }
                placement="right"
                width={600}
                closable
                onClose={onClose}
                open={visibleAttributes}
            >
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 12 }}
                    layout="horizontal"
                    ref={hForm}
                    name="Site_form"
                    initialValues={formObject}
                    onFinish={onFinish}
                >
                    <Form.Item
                        name={'selectedDevice'}
                        label={'Select Device'}
                        rules={[{ required: true, message: 'Please Select Device!' }]}
                    // style={{ width: '100%', flex: '100%' }}
                    >
                        <span style={{ display: 'flex', justifyContent: 'flex-start' }}>
                            <Select
                                // style={{ width: '75%', opacity: 1, pointerEvents: 'none' }}
                                value={selectedDevice}
                                placeholder={'Select Device'}
                                disabled={true}
                            >
                                {hierarchy &&
                                    Array.isArray(hierarchy) &&
                                    hierarchy.map((device, index) => (
                                        <Option key={index} value={`${device.AliasCode}`}>
                                            {device.DisplayCode}
                                        </Option>
                                    ))}
                            </Select>
                            <Button
                                style={{ width: '5%' }}
                                type="primary"
                                onClick={() => setTreeVisible(true)}
                                disabled={formObject && formObject.Id ? true : false}
                            >
                                <UpSquareOutlined />
                            </Button>
                        </span>
                    </Form.Item>
                    {/* <Form.Item
                        label={translation(translationCache, 'Asset')}
                        name="Asset"
                        rules={[{ required: true, message: translation(translationCache, 'Please select Asset !') }]}
                    >
                        <Input placeholder={translation(translationCache, 'Please select Asset')} />
                    </Form.Item>
                    <Form.Item
                        label={translation(translationCache, 'Device')}
                        name="Device"
                        rules={[{ required: true, message: translation(translationCache, 'Please select Device !') }]}
                    >
                        <Input placeholder={translation(translationCache, 'Please select Device')} />
                    </Form.Item> */}
                    <Form.Item
                        label={translation(translationCache, 'Parameter Type')}
                        name="Tag"
                        rules={[{ required: true, message: 'Please select ParameterType !' }]}
                    >
                        <Select
                            value={selectedParameterType}
                            placeholder={translation("Select Parameter Type")}
                            onChange={OnParameterTypeChange}
                        >
                            {parametersList &&
                                Array.isArray(Object.keys(parametersList)) &&
                                Object.keys(parametersList).map((parameterType) => (
                                    <Option key={parameterType}>{parameterType}</Option>
                                ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label={translation(translationCache, 'Parameter')}
                        name="Parameter"
                        rules={[{ required: true, message: 'Please select Parameter !' }]}
                    >
                        <Select
                            showSearch
                            // mode="multiple"
                            value={selectedParameter}
                            onChange={OnParameterChange}
                            placeholder={translation('Select Parameter')}
                        >
                            {ParameterListByType &&
                                Array.isArray(ParameterListByType) &&
                                ParameterListByType.map((param, index) => {
                                    return (
                                        <Option key={index} value={`${param.ParameterCode}`}>
                                            {`${param.ParameterCode}`}
                                        </Option>
                                    );
                                })}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label={translation(translationCache, 'Upper Limit')}
                        name="UpperLimit"
                        rules={[{ required: false, message: translation(translationCache, 'Please input UpperLimit !') }]}
                    >
                        <Input placeholder={translation(translationCache, 'Please input UpperLimit')} />
                    </Form.Item>
                    <Form.Item
                        label={translation(translationCache, 'Lower Limit')}
                        name="LowerLimit"
                        rules={[{ required: false, message: translation(translationCache, 'Please input LowerLimit !') }]}
                    >
                        <Input placeholder={translation(translationCache, 'Please input LowerLimit')} />
                    </Form.Item>
                    <Form.Item
                        label={translation(translationCache, 'Actual Value')}
                        name="Limit"
                        rules={[{ required: false, message: translation(translationCache, 'Please input Limit !') }]}
                    >
                        <Input placeholder={translation(translationCache, 'Please input Limit')} />
                    </Form.Item>

                    <Form.Item
                        label={translation(translationCache, 'Color Code')}
                        name="ColorCode"
                        rules={[{ required: true, message: translation(translationCache, 'Please input ColorCode !') }]}
                    >
                        <Input placeholder={translation(translationCache, 'Please input ColorCode')} />
                    </Form.Item>
                    <Modal
                        open={typeChangeModal}
                        // onOk={onModalsOk}
                        // okText={'Ok'}
                        onCancel={() => setTypeChangeModal(false)}
                        footer={[
                            <Button key="back" onClick={() => setTypeChangeModal(false)}>
                                No
                            </Button>,
                            <Button key="submit" onClick={onTypeChangeModalOk}>
                                Yes
                            </Button>
                        ]}>
                        Are you want to change the option. If you try to change the option, you will lose data
                    </Modal>
                    <Modal
                        open={treeVisible}
                        width={800}
                        closable
                        title={'Select Device'}
                        okText={'Add'}
                        onOk={onModalsOk}
                        onCancel={onModalCancel}
                    >
                        <div style={{ display: "flex", flexDirection: "row-reverse" }}>
                            <Checkbox
                                checked={type === 'Device'}
                                onChange={() => checkboxOnChange('Device')}
                            >
                                Device
                            </Checkbox>
                            <Checkbox
                                checked={type === 'Asset'}
                                onChange={() => checkboxOnChange('Asset')}
                            >
                                Asset
                            </Checkbox>
                        </div>
                        <HierarchyModal
                            treeData={Object.values(hierarchy)}
                            Key="Trends"
                            handleDropdownChange={hierarchyDropdownChange}
                            selectedOption={type === 'Device' ? 'Device' : 'Asset'}
                            checkedArray={checkedValue ? checkedValue : []}
                        />
                    </Modal>

                </Form>
                <DrawerFooter>
                    <Button type="primary" onClick={onClose} style={{ marginRight: 8 }}>
                        {translation(translationCache, 'Cancel')}
                    </Button>
                    <Button type="primary" onClick={onFinish}>
                        {translation(translationCache, 'Submit')}
                    </Button>
                </DrawerFooter>
            </Drawer>
        </div>
    );
};

const mapStateToProps = (state) => ({
    translationCache: state.TranslationReducer.translationCache,
    defaultHiearchy: state.LayoutReducer.DefaultHierarchy
});

export default connect(mapStateToProps)(ColorCodes);
